/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pipeline_DescriptionInputs */

const en_orders_pipeline_description = /** @type {(inputs: Orders_Pipeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by status to manage the fulfillment pipeline.`)
};

const es_orders_pipeline_description = /** @type {(inputs: Orders_Pipeline_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra por estado para administrar el flujo de cumplimiento.`)
};

/**
* | output |
* | --- |
* | "Filter by status to manage the fulfillment pipeline." |
*
* @param {Orders_Pipeline_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_pipeline_description = /** @type {((inputs?: Orders_Pipeline_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pipeline_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_pipeline_description(inputs)
	return es_orders_pipeline_description(inputs)
});